export default __webpack_public_path__ + "static/media/moostooLogo.9a0fb906.svg";